module.exports = __webpack_public_path__ + "img/IGNITE.4c2491e0.png";